import moment from "moment";

const Mobiscroll = {
  state: () => ({
    allEvents: [],
    selectedDate: "",
    isMobileDragDrop: false,
    eventsToSave: [],
    isCalendarPopup: false
  }),
  getters: {
    isCalendarPopup(state) {
      return state.isCalendarPopup;
    },
    eventsToSave(state) {
      return state.eventsToSave;
    },
    selectedDateMobiscroll(state) {
      return state.selectedDate;
    },
    isMobileDragDrop(state) {
      return state.isMobileDragDrop;
    },
    isSelectedDatePassedMobiscroll(state) {
      if (!state.selectedDate) return false;
      const today = moment().format("YYYY-MM-DD");
      const selectedDate = moment(state.selectedDate, "YYYY-MM-DD");
      return selectedDate.isBefore(moment(today, "YYYY-MM-DD"));
    },
    isSelectedDateTodayOrBefore(state) {
      if (!state.selectedDate) return false;
      const today = moment().format("YYYY-MM-DD");
      const selectedDate = moment(state.selectedDate, "YYYY-MM-DD");
      return selectedDate.isSameOrBefore(moment(today, "YYYY-MM-DD"));
    },
    eventsMobiscroll(state) {
      if (!state.allEvents || !state.selectedDate) return [];
      return state.allEvents.filter(
        e => moment(e.start).format("YYYY-MM-DD") == state.selectedDate
      );
    },
    appointmentsMobiscroll(state, getters) {
      return getters.eventsMobiscroll.reduce((acc, e) => {
        if (e.type == "appointment") {
          const newContent = e.content.replace(/<b>.*?<\/b>/g, "");
          acc.push({
            ...e,
            start: e.real_start,
            end: e.real_end,
            color: "#ffffff",
            content: newContent
          });
        }
        return acc;
      }, []);
    },
    blocksMobiscroll(state, getters) {
      return getters.eventsMobiscroll.reduce((acc, e) => {
        if (e.type == "block") {
          acc.push({ ...e, background: "#dce0ec" });
        }
        return acc;
      }, []);
    },
    startTimeMobiscroll(state, getters) {
      if (!getters.blocksMobiscroll.length) return "00:00";
      const minStartDate = getters.blocksMobiscroll.reduce(
        (minDate, currentItem) => {
          const currentDate = new Date(currentItem.start);
          return currentDate < minDate ? currentDate : minDate;
        },
        new Date(getters.blocksMobiscroll[0].start)
      );
      let formattedStart = moment(minStartDate).format("HH:mm");
      formattedStart = moment(formattedStart, "HH:mm");
      const limitStart = moment("01:00", "HH:mm");
      if (formattedStart.isBefore(limitStart)) return "00:00";
      return moment(minStartDate)
        .subtract(0.25, "hours")
        .format("HH:mm");
    },
    endTimeMobiscroll(state, getters) {
      if (!getters.blocksMobiscroll.length) return "00:00";
      const maxEndDate = getters.blocksMobiscroll.reduce(
        (maxDate, currentItem) => {
          const currentEndDate = moment(currentItem.end);
          return currentEndDate.isAfter(maxDate) ? currentEndDate : maxDate;
        },
        moment(getters.blocksMobiscroll[0].end)
      );
      let formattedEnd = moment(maxEndDate).format("HH:mm");
      formattedEnd = moment(formattedEnd, "HH:mm");
      const limitEnd = moment("23:00", "HH:mm");
      if (formattedEnd.isAfter(limitEnd)) return "00:00";
      return moment(maxEndDate)
        .add(0.25, "hours")
        .format("HH:mm");
    }
  },
  mutations: {
    SET_MOBISCROLL_EVENTS(state, events) {
      state.allEvents = [...events];
    },
    SET_MOBISCROLL_DATE(state, date) {
      if (date) state.selectedDate = moment(date).format("YYYY-MM-DD");
      state.eventsToSave = [];
    },
    TOGGLE_MOBISCROLL(state, value) {
      const elVuecalBody = document.querySelector(".vuecal__body");
      if (value) {
        state.isMobileDragDrop = true;
        document.body.style.overflow = "hidden";
        if (elVuecalBody) elVuecalBody.classList.add("invisible");
      } else {
        // state.selectedDate = "";
        state.eventsToSave = [];
        state.isMobileDragDrop = false;
        document.body.style.overflow = null;
        if (elVuecalBody) elVuecalBody.classList.remove("invisible");
      }
    },
    UPDATE_EVENTS_TO_SAVE(state, value) {
      state.eventsToSave = value;
    },
    TOGGLE_CALENDAR_POPUP(state, value) {
      state.isCalendarPopup = value;
    }
  },
  actions: {}
};

export default Mobiscroll;
